/**
 * Presentation filters (currency / capitalize).
 * Installed on globalProperties as $filters.
 */
export const filters = {
  currency(value, currency = 'BRL') {
    const currencyFormatter = Intl.NumberFormat('pt', {
      style: 'currency',
      currency,
    })
    return currencyFormatter.format(value)
  },

  capitalize(value) {
    const words = value?.toLowerCase().split(' ') || []
    return (
      words?.map((word) => word[0].toUpperCase() + word.substring(1)).join(' ') ||
      value
    )
  },
}

export function installFilters(app) {
  app.config.globalProperties.$filters = filters
}
